import { render, staticRenderFns } from "./rechargeDialog.vue?vue&type=template&id=1b532166&scoped=true&"
import script from "./rechargeDialog.vue?vue&type=script&lang=js&"
export * from "./rechargeDialog.vue?vue&type=script&lang=js&"
import style0 from "./rechargeDialog.vue?vue&type=style&index=0&id=1b532166&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b532166",
  null
  
)

export default component.exports